/** @file keyDots: the frames where a clip keys one node (the first half only for mirrorHalf clips). */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import { mirrorStart } from './mirrorStart';

/** Sorted frames of the keys naming `node`; with `mirrorHalf`, frames at or after `mirrorStart` are left out. */
export function keyDots(clip: Pick<Clip, 'keys' | 'mirrorHalf' | 'frames' | 'loopStart'>, node: string): number[] {
  const end = mirrorStart(clip) ?? Infinity;
  return clip.keys.filter((k) => k.frame < end && node in k.nodes).map((k) => k.frame).sort((a, b) => a - b);
}
